/*
 * @Author: zhaoyang
 * @Date: 2020-11-25 14:26:13
 * @LastEditors: your name
 * @LastEditTime: 2021-03-19 17:24:39
 * @Description: 发送系统通知（首先系统应允许浏览器发送通知）
 */
export default function notify(title, options, time = 5000) {
  if (!('Notification' in window)) {
    console.error(
      'Sorry bro, your browser is not good enough to display notification'
    );
    return new Promise();
  }
  return new Promise(resolve => {
    Notification.requestPermission(function(permission) {
      let notification;
      // 统一授权通知
      if (permission === 'granted') {
        console.log(permission);
        notification = new Notification(title, options);
        setTimeout(function() {
          notification.close(); //关闭桌面通知
        }, time);
        resolve(notification);
      } else if (permission === 'denied') {
        console.log(permission);
      }
      notification.onerror = function(e) {
        //当有错误发生时会onerror函数会被调用
        console.error(e);
      };
    });
  });
}

/**
 * @description: 提醒用戶開啟web通知
 */
export async function requestPermission(preFn) {
  if (!('Notification' in window)) {
    console.error(
      'Sorry bro, your browser is not good enough to display notification'
    );
    return Promise.resolve()
  }
  let needPermission = Notification.permission !== 'granted'
  if(!needPermission) return Promise.resolve()
  if (typeof preFn === 'function'){
    let status = await preFn()
    if(!status) return Promise.resolve()
  } 
  return new Promise((resolve) => {
    Notification.requestPermission(function(permission) {
      // 统一授权通知
      if (permission === 'granted') {
        let notification = new Notification('成功開通');
        setTimeout(function() {
          notification.close(); //关闭桌面通知
        }, 6000);
        resolve(notification)
      } else {
        resolve(false)
      }
    });
  });
}
